import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  icon,
  children
}: PageHeaderProps) {
  return <div className="relative bg-white rounded-2xl border border-slate-200/60 shadow-[0_1px_3px_rgba(0,0,0,0.04)] overflow-hidden animate-slide-up mb-4 lg:mb-6" data-id="element-273">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-[#eef2fc]/30 to-[#d5e0f7]/20 pointer-events-none" data-id="element-274" />

      <div className="relative p-4 sm:p-5 lg:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3 lg:gap-4" data-id="element-275">
        <div className="flex items-center gap-3 lg:gap-4" data-id="element-276">
          <div className="p-2 lg:p-3 bg-[#2952C4] text-white rounded-xl shadow-sm flex-shrink-0" data-id="element-277">
            {icon}
          </div>
          <div data-id="element-278">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 font-heading tracking-tight" data-id="element-279">
              {title}
            </h2>
            {subtitle && <p className="text-xs lg:text-sm text-slate-500 mt-0.5 font-medium" data-id="element-280">
                {subtitle}
              </p>}
          </div>
        </div>

        {children && <div className="flex items-center gap-2 lg:gap-3 flex-wrap" data-id="element-281">
            {children}
          </div>}
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#2952C4] via-[#5483df] to-transparent opacity-80" data-id="element-282" />
    </div>;
}